module.exports = import("https://cdn.skypack.dev/@pixi/filter-kawase-blur@3.2.0");;